module.exports = __webpack_public_path__ + "static/media/scottsdale_figure_and_studio_painting.10165cd4.jpg";